import { GameInfoConfig } from './games.model';
import Spin from '../../assets/Games/spin.png';
import Fire from '../../assets/Games/fire.png';
import x10 from '../../assets/Games/x10.png';

export const gameInfoConfig: GameInfoConfig = {
  hideRTP: false,
  hideNumberOfLines: false,
  hideMinBet: false,
  hideMaxBet: false,
  hideCustomFields: false,
  hideLongDescription: false,
  hideRules: false,
  similarGames: {
    take: 8,
  },
  gameFeatures: [
    {
      iconPath: x10,
      featureText: 'Multipliers X10',
      gmsCustomField: 'bonus-round',
      tooltipText: 'Multipliers X10',
    },
    {
      iconPath: Fire,
      featureText: 'Staked Wilds',
      gmsCustomField: 'app-bundle-active',
      tooltipText: 'Staked Wilds',
    },
    {
      iconPath: Spin,
      featureText: 'Free Spins Bonus',
      gmsCustomField: 'free-spins',
      tooltipText: 'Free Spins Bonus',
    },
  ],
};
